import { Snippet, YouTubeVideoResponse } from "@interfaces/Youtube";
import emitter from "./emitter";
import { getAllRegistrations, saveOrUpdateRegistrationData } from "./indexdb";

// Variável para armazenar o reprodutor do YouTube
var player: YT.Player;

// Array para armazenar os IDs dos vídeos na lista de reprodução
const apiKey = "AIzaSyBEVok2AYMRtWKGMrPcX26TFQYYv-0XVx8"; // Substitua com sua chave de API do YouTube
var videoId: string = "j9__UCv_VuY";
var playlist: ['j9__UCv_VuY']

var listIndex: string = ''
export function searchYouTube(query: string) {
  // Construa a URL da API do YouTube
  const apiUrl = `https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=1&q=${query}&type=video&key=${apiKey}`;

  // Faça uma solicitação AJAX usando Fetch API
  return fetch(apiUrl)
    .then((response) => response.json())
    .then((data) => {
      // Extraia o ID do vídeo do resultado da pesquisa
      const videoId = data.items[0].id.videoId;

      // Construa a URL do vídeo
      const videoUrl = `https://www.youtube.com/watch?v=${videoId}`;
      console.log(videoUrl);
      return videoId;
    })
    .catch((error) => {
      console.error("Erro ao buscar vídeos do YouTube:", error);
    });
}

export async function addVideo(video: string, username: string = "teste") {
  // Verifica se o valor inserido é um link do YouTube
  if (video.includes("youtube.com")) {
    const url = new URL(video);
    video = url.searchParams.get("v") as string;
  }

  // Use a API do YouTube Data para obter informações sobre o vídeo
  const apiKey = "AIzaSyBEVok2AYMRtWKGMrPcX26TFQYYv-0XVx8"; // Substitua pela sua chave de API do YouTube Data
  const videoInfo = await fetch(
    `https://www.googleapis.com/youtube/v3/videos?id=${video}&part=snippet&key=${apiKey}`
  );
  const videoData = (await videoInfo.json()) as YouTubeVideoResponse;

  if (videoData.items.length > 0) {
    let videoId = videoData.items[0].id;
    let snippet = videoData.items[0].snippet as Snippet;
    console.info(snippet);

    var { title, thumbnails } = snippet;

    updatePlaylist("addVideo", {
      username,
      title,
      image: thumbnails.default,
      videoId,
    });
    return { username, title, image: thumbnails.default, videoId };
  }
}

export function updatePlaylist(on: string, data: any) {
  console.log("ON?", on)
  emitter.emit("playlistUpdate", { on, data });
}


// Carrega o player do YouTube
export async function onYouTubeIframeAPIReady() {
  console.log('ON - onYouTubeIframeAPIReady')
  const playElement = document.querySelector('wc-youtube-video')?.shadowRoot?.querySelector('#player') as HTMLElement
  player = new YT.Player(playElement, {
    height: "360",
    width: "640",
    playlist: playlist,
    videoId,
    playerVars: {
      autoplay: 1,
      controls: 1,
    },
    events: {
      onReady: Boolean(localStorage.getItem('infinite')) ? onReadyList: onReady,
      onStateChange: onPlayerStateChange,
    },
  } as YT.PlayerOptions);
}

export function stopVideo() {
  console.log('stop')
  // player.stopVideo();
  player.pauseVideo();
}

export function pauseVideo() {
  player.pauseVideo();

}

export function playVideo(data: any) {
  const { id, videoId } = data
  removeActive()
  setActive(id)
  player.loadVideoById(videoId);
}

export function nextVideo() {
  const id = document.querySelector('wc-youtube-playlist')?.shadowRoot?.querySelector('li[active]')?.getAttribute('id') as string

  saveOrUpdateRegistrationData('playlist', { id, played: true })
  onReady()
}

export function previousVideo() {
  let videoId = document.querySelector('wc-youtube-playlist')?.shadowRoot?.querySelector('li[active]')
  ?.previousElementSibling?.getAttribute('data-video') as string

  removeActive()
  player.loadVideoById(videoId);
}

// Função chamada quando o estado do player muda (fim do vídeo)
export function onPlayerStateChange(event: any) {
  console.log("onPlayerStateChange", event);

  if (event.data === YT.PlayerState.ENDED) {
    saveOrUpdateRegistrationData('playlist', { id: listIndex, played: true })
    onReady()

  }

  if (event.data === YT.PlayerState.PLAYING) {
    setActive(listIndex)
  }

}


function removeActive(){
  const currentElement = document.querySelector('wc-youtube-playlist')?.shadowRoot?.querySelectorAll('li[active]')
  currentElement?.forEach(el => el.removeAttribute('active'))
}

function setActive(id:string){
  document.querySelector('wc-youtube-playlist')?.shadowRoot?.getElementById(id)?.setAttribute('active','')

}

export function onReady() {
  removeActive()

  getAllRegistrations('playlist', (registrations: []) => {
    try {
      let { id, videoId } = registrations.find((objeto: any) => objeto.played !== true ) as any
      listIndex = id
      player.loadVideoById(videoId);
    } catch (error) {
      player.loadVideoById(videoId);
    }
  });
}


export function onReadyList() {
  removeActive()

  getAllRegistrations('playlist', (registrations: []) => {
    try {
      const listaDeVideoIds = registrations.map((video:any) => video.videoId);
      player.loadPlaylist(listaDeVideoIds);
    } catch (error) {
      player.loadVideoById(videoId);
    }
  });
}


